import store from '@/store';
import { RouteName } from './../enums/route-name-type';
import { createRouter, createWebHistory, Router } from 'vue-router';
import { StepType } from '../../interfaces/enums/step-type';
import globals from '@/utils/globals';
import { JourneyMenuTab } from '@/enums/journey-menu-tab';

const wildcardPath = '/:pathMatch(.*)*';

export const router: Router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			name: RouteName.MY_JOURNEY,
			path: '/account/my-journey/',
			component: () => import('../presentation/components/Views/Journey/JourneyView.vue'),
			beforeEnter: (to, from, next): void => {
				store.actions.setJourneySteps();
				next();
			},
			children: [
				{
					name: RouteName.DISCOVER,
					path: `${RouteName.DISCOVER}/${wildcardPath}`,
					component: () => import('../presentation/components/Views/Journey/Steps/Discover/Discover.vue'),

					beforeEnter: (to, from, next): void => {
						store.actions.setCurrentJourneyStepByType(StepType.DISCOVER);
						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.MY_JOURNEY);
						globals.journeyTracker.trackFakePageView(RouteName.DISCOVER);

						next();
					},
				},
				{
					name: RouteName.EVALUATE,
					path: `${RouteName.EVALUATE}/${wildcardPath}`,
					component: () => import('../presentation/components/Views/Journey/Steps/Evaluate/Evaluate.vue'),

					beforeEnter: (to, from, next): void => {
						store.actions.setCurrentJourneyStepByType(StepType.EVALUATE);
						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.MY_JOURNEY);
						globals.journeyTracker.trackFakePageView(RouteName.EVALUATE);
						next();
					},
				},
				{
					name: RouteName.PREPARE_TO_APPLY,
					path: `${RouteName.PREPARE_TO_APPLY}/${wildcardPath}`,

					component: () => import('../presentation/components/Views/Journey/Steps/PrepareToApply/PrepareToApply.vue'),
					beforeEnter: (to, from, next): void => {
						store.actions.setCurrentJourneyStepByType(StepType.PREPARE_TO_APPLY);

						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.MY_JOURNEY);
						globals.journeyTracker.trackFakePageView(RouteName.PREPARE_TO_APPLY);
						next();
					},
				},
				{
					name: RouteName.COMMIT,
					path: `${RouteName.COMMIT}/${wildcardPath}`,

					component: () => import('../presentation/components/Views/Journey/Steps/Commit/Commit.vue'),
					beforeEnter: (to, from, next): void => {
						store.actions.setCurrentJourneyStepByType(StepType.COMMIT);

						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.MY_JOURNEY);
						globals.journeyTracker.trackFakePageView(RouteName.COMMIT);
						next();
					},
				},
				{
					name: RouteName.STUDY,
					path: `${RouteName.STUDY}/${wildcardPath}`,

					component: () => import('../presentation/components/Views/Journey/Steps/Study/Study.vue'),
					beforeEnter: (to, from, next): void => {
						store.actions.setCurrentJourneyStepByType(StepType.STUDY);

						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.MY_JOURNEY);
						globals.journeyTracker.trackFakePageView(RouteName.STUDY);
						next();
					},
				},
				{
					name: RouteName.GET_READY,
					path: `${RouteName.GET_READY}/${wildcardPath}`,
					component: () => import('../presentation/components/Views/Journey/Steps/GetReady/GetReady.vue'),
					beforeEnter: (to, from, next): void => {
						store.actions.setCurrentJourneyStepByType(StepType.GET_READY);

						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.MY_JOURNEY);
						globals.journeyTracker.trackFakePageView(RouteName.GET_READY);
						next();
					},
				},
				{
					name: RouteName.TOOLS,
					path: `${RouteName.TOOLS}/${wildcardPath}`,
					component: () => import('../presentation/components/Views/Journey/Toolbox/Toolbox.vue'),
					beforeEnter: (to, from, next): void => {
						store.mutations.setCurrentJourneyMenuTab(JourneyMenuTab.TOOLBOX);
						globals.journeyTracker.trackFakePageView(RouteName.TOOLS);

						next();
					},
				},
			],
		},
	],
	scrollBehavior: (to, from): any => {
		if (to.query?.scrollTo || from.query?.scrollTo) return;
		return {
			top: 0,
			behavior: 'smooth',
		};
	},
});

router?.beforeEach((to, from, next) => {
	store.mutations.setIsMenuActive(to.name === RouteName.TOOLS || to.name === RouteName.MY_JOURNEY);
	store.mutations.setCurrentRoute(to);
	next();
});
